const MIGRATION = {
    PLAYER_MIGRATED_COOKIE : "player_migrated",
    LOADED_WITH_MIGRATION_TOKEN_SESSION_STORAGE_KEY: "loadedWithMigrationToken",
    MIGRATION_SOURCE_QUERY_PARAM: "utm_source",
    MIGRATION_SOURCE_QUERY_PARAM_VALUE: 'player_migration',
    MIGRATION_TOKEN_QUERY_PARAM: "utm_content",
    BUSINESS_CORRELATION_ID_QUERY_PARAM: "utm_id",
    UK_SCV_PLAYER_MIGRATED_COOKIE: "uk_scv_player_migrated",
};

export default MIGRATION;